import SoftLimitCalendar, { SoftLimitProps } from './SoftLimitCalendar'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import { dateToYMDformat } from 'utils/date'
import React, { useState } from 'react'
import Popup from './Popup'

interface DatePickerPopupProps extends SoftLimitProps {
  value?: string
  minDate?: string
  maxDate?: string
  onChange: (date: string) => void
  close?: basic.BasicFunc
  /** dodatkowo wyłączone dni (np. całkowicie zajęte) */
  tileDisabled?: (args: { date: Date, view: string }) => boolean
}

const DatePickerPopup: React.FC<DatePickerPopupProps> = ({ value: initValue, minDate, maxDate, softMinDate, softMaxDate, getBlockedModal, tileDisabled, onChange, close: _close }) => {
  const [value, setValue] = useState<Date | null>(initValue ? new Date(initValue) : null)
  const { lang } = useTranslation()

  const { goBack } = useHistory()
  const close = _close || goBack
  const onTouchStart = (e: React.TouchEvent) => {
    const initialX = e.touches[0].clientX
    const initialY = e.touches[0].clientY

    const touchend = () => {
      window.removeEventListener('touchmove', touchmove)
      window.removeEventListener('touchend', touchend)
    }

    const touchmove = (e: TouchEvent) => {
      const currentX = e.touches[0].clientX
      const currentY = e.touches[0].clientY
      if (Math.abs(initialX - currentX) > 100) {
        touchend()
        handleClickArrow(currentX < initialX)
      } else if (Math.abs(initialY - currentY) > 20) {
        touchend()
      }
    }

    const handleClickArrow = (next: boolean) => {
      const element = document.querySelector(`.react-calendar__navigation__${next ? 'next' : 'prev'}-button`)
      if (element) (element as HTMLElement).click()
    }

    window.addEventListener('touchmove', touchmove)
    window.addEventListener('touchend', touchend)
  }

  return (
    <Popup
      save={() => {
        if (value) onChange(dateToYMDformat(value))
        close()
      }}
      close={_close}>
      <div onTouchStart={onTouchStart}>
        <SoftLimitCalendar
          locale={lang}
          softMinDate={softMinDate}
          softMaxDate={softMaxDate}
          getBlockedModal={getBlockedModal}
          minDetail='year'
          minDate={minDate ? new Date(minDate) : undefined}
          maxDate={maxDate ? new Date(maxDate) : undefined}
          value={value}
          showNeighboringMonth={false}
          tileDisabled={tileDisabled}
          onChange={date => {
            if (date) setValue(date as Date)
          }}
        />
      </div>
    </Popup>
  )
}

export default DatePickerPopup